import type { ReactNode } from 'react'
import { caracLisHtml } from './caracRich'

/** Cantidad sin ceros sobrantes (1, 2,5, 0,75). '—' si no hay dato (0). */
export function fmtQty(n: number): string {
  if (!n || !Number.isFinite(n)) return '—'
  return n.toLocaleString('es-ES', { maximumFractionDigits: 3 })
}

/** Contenido de características como lista de viñetas: cada línea es un `<li>` con el
 *  formato inline (negrita/cursiva/subrayado) que el usuario haya aplicado. El HTML
 *  se sanea (whitelist b/i/u) antes de pintarse. */
export function renderRich(text: string): ReactNode {
  const inner = caracLisHtml(text)
  if (!inner) return null
  return <ul className="fc-carac-list" dangerouslySetInnerHTML={{ __html: inner }} />
}

/** Aviso fijo de seguridad dentro de las características (vista e impresión). */
export function CaracAviso() {
  return (
    <div className="f-carac-aviso">
      <strong>¡IMPORTANTE!</strong><br />
      Durante todo el proceso manipular el producto con guantes.
    </div>
  )
}

/** Une los registros de característica en un único texto plano multilínea
 *  ("nombre: descripción" por registro), para edición y render enriquecido. */
export function joinCaracteristicas(items: { nombre: string; descripcion: string }[]): string {
  return items
    .map((r) => (r.nombre && r.descripcion ? `${r.nombre}: ${r.descripcion}` : r.nombre || r.descripcion))
    .filter(Boolean)
    .join('\n')
}
